<template>
  <div v-if="industries.length" id="rankingWidget" :class="{'hp-card': !isDesktop}">
    <h4 class="has-text-weight-bold" :class="{'color-blue-dark': !isDesktop}">Our ranking <span class="has-text-weight-normal">(Rolling 12 months):</span></h4>
    <hr class="separator" v-if="!isDesktop"/>
    <div v-for="(rank, idx) in industries">
      <div :class="{'font-size-12':isTablet, 'font-size-11':isMobile}">
        <span class="has-text-weight-bold" :class="{'font-size-16':!isMobile, 'font-size-14':isMobile}">#{{ rank.industryRanking }}</span>
        in
        <router-link
            v-if="rank.isMainIndus"
            class="link--v2"
            :to="{ name: 'Industries-Category', params: { slug: rank.slug } }">
          {{ rank.name }}
        </router-link>
        <router-link
            v-else
            class="link--v2"
            :to="{ name: 'SubIndustriesDetail', params: { indSlug: mainIndustry.slug, subIndSlug: rank.slug } }">
          {{ rank.name }}
        </router-link>
      </div>
      <hr class="separator" v-if="!isDesktop && idx != industries.length - 1"/>
    </div>
  </div>
</template>
<script>
import {misc} from '@/mixins'

export default {
  name: 'RankInIndustries',
  props: {
    industries: {
      type: Array,
      default: null, //Null so that if prop not passed then can be fetched within this component
    }
  },
  mixins: [misc],
  computed: {
    mainIndustry () {
      return this.industries.find(indObj => indObj.isMainIndus)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

#rankingWidget {
  border-radius: 10px;
  border: 1px solid map-get($colors, 'gray-light');
  background-color: #fff;
  padding: 6px 18px 18px;
  line-height: 35px;

  @include not-desktop {
    padding-top: 3px;
    padding-bottom: 1px;

    .separator {
      background-color: map-get($colors, 'gray2');
      margin: 0;
      opacity: 0.1;
    }
  }

  @include tablet {
    font-size: 16px;

    .link--v2 {
      margin: 0 0 0 22px;
    }
  }

  @include mobile {
    font-size: 12px;

    .link--v2 {
      margin: 0 0 0 29px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/RankInIndustries.vue